import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import useCart from 'services/cart/hooks/use-cart'
import useAddToCart from 'services/googleAnalytics/use-add-to-cart'

function AddToCartOnClick ({ id, quantity, name, price, children }) {
  const cart = useCart()

  const handleClick = () => {
    cart.set(
      id.toString(),
      quantity + (cart.get(id.toString()) || 0)
    )
    useAddToCart(id, name, price, quantity)
  }

  return (
    <div onClick={handleClick}>
      {children}
    </div>
  )
}

AddToCartOnClick.defaultProps = {
  id: null,
  quantity: null,
  price: null,
  name: ''
}

AddToCartOnClick.propTypes = {
  id: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired
}

export default observer(AddToCartOnClick)
